import styled from 'styled-components';

export const PremiumLabelBig = styled.label`
  color: var(--grey500);
  font-feature-settings: 'clig' off, 'liga' off;
  /* 14px/regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  cursor: text;
`;
